module.exports = __webpack_public_path__ + "img/appleMusic.ef5bb368.svg";